import { Button } from '@gearbelt/ui/components';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex h-full flex-col items-center justify-center">
      <div className="flex w-[700px] flex-col items-center gap-4 rounded-lg bg-white p-10 text-center shadow-lg">
        <h1 className="text-default-text text-xl font-medium">The page you are looking for doesn&apos;t exist.</h1>
        <p className="text-secondary-text text-sm">You may have mistyped the address or the page may have moved.</p>
        <Button variant="default" onClick={() => navigate('/')}>
          Click here to go to home
        </Button>
      </div>
    </div>
  );
}
